import { render, staticRenderFns } from "./GroupExamplesPopover.vue?vue&type=template&id=368299bb&scoped=true"
import script from "./GroupExamplesPopover.vue?vue&type=script&lang=ts"
export * from "./GroupExamplesPopover.vue?vue&type=script&lang=ts"
import style0 from "./GroupExamplesPopover.vue?vue&type=style&index=0&id=368299bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368299bb",
  null
  
)

export default component.exports